<mat-card-content>
    <div>
        <mat-progress-spinner diameter=50 mode="indeterminate"  color="accent"></mat-progress-spinner>
    </div>  
</mat-card-content>
